// extracted by mini-css-extract-plugin
export default {"popup":"mZAa7aB0NdWtCJXtjxOr","svgContainer":"gZGKcvyoLzfA8fhNTIVw","selectorSvg":"bS9aCJefdyCQ2IzjuPnF","popupContainer":"MJOctcwN_Zpu8_fnsBod"};